import loadable from '@loadable/component';
import query from './query.graphql';

const EditorialContentListingPageLoader = loadable(() =>
  import(/* webpackChunkName: "article" */ './editorial-content-listing')
);

EditorialContentListingPageLoader.graphQL = query;
EditorialContentListingPageLoader.variables = ({ offset }) => {
  const pageSize = 20;
  const parsedOffset =
    typeof offset === 'string' ? parseInt(offset, 10) : offset;

  return {
    page:
      parsedOffset === null || parsedOffset === undefined
        ? 1
        : parsedOffset / pageSize + 1,
    pageSize,
  };
};

export default EditorialContentListingPageLoader;
